import { isNullOrWhitespace } from "@common/stringOperations";

// Shared by every template driven edit page: a field counts as filled in only when it would render as
// something the user can see, so blank strings, empty lists and unparsable numbers and dates read as empty.
export function hasFieldData(value: any): boolean {
    if (value === undefined || value === null) {
        return false;
    }
    if (typeof value === "boolean" && !value) {
        return false;
    }
    if (Array.isArray(value) && value.length === 0) {
        return false;
    }
    if (typeof value === "string" && isNullOrWhitespace(value)) {
        return false;
    }
    if (typeof value === "number" && isNaN(value)) {
        return false;
    }
    if (value instanceof Date && isNaN(value.getTime())) {
        return false;
    }

    return true;
}
